"use client";

import { SwiperSlide } from "swiper/react";
import SwiperCarousel from "@/components/plugins/swiper/SwiperCarousel";
import TextSubHeader from "@/components/typography/TextSubHeader";
import TextHeader from "@/components/typography/TextHeader";
import TextContent from "@/components/typography/TextContent";
import SwiperSlideImage from "@/components/plugins/swiper/SwiperSlideImage";
import imgSlide1 from "@/assets/images/screens/homepage/active-pros-1.jpg";
import imgSlide2 from "@/assets/images/screens/homepage/active-pros-2.jpg";
import imgSlide3 from "@/assets/images/screens/homepage/active-pros-3.jpg";
import imgSlide4 from "@/assets/images/screens/homepage/active-pros-4.jpg";
import imgSlide5 from "@/assets/images/screens/homepage/active-pros-5.jpg";
import imgSlide6 from "@/assets/images/screens/homepage/active-pros-6.jpg";
import DrawActiveProsFirst from "@/screens/homepage/components/drawings/DrawActiveProsFirst";
import DrawActiveProsSecond from "@/screens/homepage/components/drawings/DrawActiveProsSecond";

export default function ActivePros() {
  const slides = [
    {
      image: imgSlide1,
      content:
        "Wewnętrzny oraz zewnętrzny, całoroczny basen z podgrzewaną wodą",
    },
    {
      image: imgSlide2,
      content: "Narciarnia i rowerownia",
    },
    {
      image: imgSlide3,
      content: "Kompleks saun: sucha, parowa, ziołowe oraz ceremonialna",
    },
    {
      image: imgSlide4,
      content: "Strefa fitness i siłownia",
    },
    {
      image: imgSlide5,
      content: "Otwarta, nowoczesna restauracja z żywym ogniem",
    },
    {
      image: imgSlide6,
      content: "Lobby Bar",
    },
  ];

  return (
    <div className="pb-16 pt-12 lg:pb-24 lg:pt-24">
      <div className="mb-16 lg:mb-24">
        <div className="m-auto max-w-screen-sm px-5">
          <div className="relative z-10">
            <TextSubHeader>
              <h2>Infrastruktura kompleksu</h2>
            </TextSubHeader>
            <TextHeader>
              <span className="relative z-10">Od</span>{" "}
              <span className="relative inline-block">
                <span className="relative z-10">aktywnego</span>
                <DrawActiveProsFirst className="absolute inset-x-2 top-3" />
              </span>{" "}
              <span className="relative z-10">wypoczynku po pełen</span>{" "}
              <span className="relative inline-block">
                <span className="relative z-10">relaks!</span>
                <DrawActiveProsSecond className="absolute -left-5 -right-12 top-2" />
              </span>
            </TextHeader>
            <TextContent>
              Oferta Tremont Szczyrk skierowana jest zarówno do gości
              indywidualnych, rodzin z dziećmi, jak i klienta biznesowego.
              Kompleksowa i bogata infrastruktura to przestrzeń, która spełni
              oczekiwania każdej z docelowych grup, przekładając się na wysokie
              zyski właścicieli apartamentów.
            </TextContent>
          </div>
        </div>
      </div>
      <SwiperCarousel>
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <SwiperSlideImage image={slide.image}>
              {slide.content}
            </SwiperSlideImage>
          </SwiperSlide>
        ))}
      </SwiperCarousel>
    </div>
  );
}
